import { useState, useEffect } from 'react';
import { supportedLanguagesWithVoices } from 'flow/types/CreateSoundTypes';

export const useVoiceSelection = (languageCode: string) => {
    const getInitialVoice = (langCode: string) => {
        const language = supportedLanguagesWithVoices.find(
            (lang) => lang.code === langCode,
        );
        return language?.voices[0]?.id || '';
    };

    const [voice, setVoice] = useState(getInitialVoice(languageCode));

    const currentLanguage = supportedLanguagesWithVoices.find(
        (lang) => lang.code === languageCode,
    );

    const availableVoices = currentLanguage ? currentLanguage.voices : [];

    // Update voice when language changes
    useEffect(() => {
        const newVoice = getInitialVoice(languageCode);
        setVoice(newVoice);
    }, [languageCode]);

    return {
        voice,
        setVoice,
        availableVoices,
    };
};
